module.exports = __webpack_public_path__ + "img/16581308_L.fd265541.png";